import { FaArrowDown, FaArrowUp } from "react-icons/fa";

export const SortedIcon = ({ label, order, sortBy }) => {
  if (sortBy === label && order === 'asc') return <FaArrowUp />;

  if (sortBy === label && order === 'desc') return <FaArrowDown />;

  return <FaArrowUp />;
};
